// ============================================================
// HIGHLIGHTS - los 3 o 4 datos que van arriba del todo
// ------------------------------------------------------------
// Esto es lo primero que ve alguien que llega desde un anuncio y
// decide en dos segundos si sigue leyendo. Van cifras verificadas,
// nunca promesas. Si no está en facts[], no va aquí.
// ============================================================

import type { L } from './config'

export const HIGHLIGHTS: Record<string, L<string[]>> = {
  credito: {
    es: ['$10 al mes', 'Sin revisión de crédito', 'Sin depósito', '4 burós'],
    en: ['$10 a month', 'No credit check', 'No deposit', '4 bureaus'],
  },
}

export const highlightsFor = (slug: string): L<string[]> | undefined =>
  HIGHLIGHTS[slug]
